import script from "./Catalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=ts"

import "./Catalog.vue?vue&type=style&index=0&id=383e0820&lang=scss"

const __exports__ = script;

export default __exports__